var base64 = require('./base64.js');
var custEvent = require('./custEvent.js');

var uniqueId = 0,
    prefix = 'ctrip_sequence';

module.exports = function (sdk, config) {
    var sniff = sdk.sniff,
        encodeParam = function encodeParam(param) {
        param = encodeURIComponent(JSON.stringify(param));
        return sniff.ctripUseBase64 ? base64.encode(param) : param;
    },
        decodeParam = function decodeParam(param) {
        return JSON.parse(sniff.ctripUseBase64 ? base64.decode(param) : decodeURIComponent(param));
    },
        callbacks = {};

    var bridge = sdk.util.extend({
        loadURL: function loadURL(scheme) {
            var iframe = document.createElement("iframe"),
                cont = document.body || document.documentElement;
            iframe.style.display = "none";
            iframe.setAttribute('src', scheme);
            cont.appendChild(iframe);
            setTimeout(function () {
                cont.removeChild(iframe);
                iframe = null;
            }, 200);
        },
        callNative: function callNative(param) {
            var paramString = encodeParam(param);
            if (sniff.ios) {
                bridge.loadURL(sniff.bridgeScheme + paramString);
            } else if (sniff.android) {
                nativeModule = window[param.service + '_a'];
                if (nativeModule) {
                    nativeFunction = nativeModule[param.action];
                    if (nativeFunction) {
                        nativeFunction.call(param.service, paramString);
                    }
                }
            } else if (sniff.winos) {
                window.external.notify(paramString);
            }
        },
        invoke: function invoke(service, action, param, tagName, callback) {
            var sequenceId = uniqueId++;
            param = param || {};
            param.service = service;
            param.action = action;
            param.callback_tagname = (tagName || prefix) + '_id=' + sequenceId;
            callbacks[sequenceId] = callback;
            bridge.callNative(param);
        }
    }, custEvent);

    var callCallback = function callCallback(callback, param) {
        try {
            callback.call(sdk, param);
        } catch (e) {
            config.debug && console.error('[HySDK] Callback Function Error', e);
        }
    };

    var execCallback = function execCallback(data) {
        var response;
        try {
            response = decodeParam(data);
        } catch (e) {
            config.debug && console.warn(data + ' cannot decode.');
        }
        if (response) {
            var tagname = (response.tagname || '').split('_id=')[0],
                param = response.param || {},
                sequenceId = (response.tagname || '').split('_id=')[1];
            if (sequenceId) {
                if (callbacks[sequenceId]) {
                    var callback = callbacks[sequenceId];
                    delete callbacks[sequenceId];
                    callCallback(callback, param);
                }
            }
            if (tagname) {
                bridge.trigger(tagname, param);
                sdk.ctrip.trigger(tagname, param);
            }
        }
    };

    global.app = window.app || {};

    global.app.callback = function (data) {
        config.debug && console.info(data);
    };

    global.__writeLocalStorage = function (key, jsonValue) {
        if (jsonValue && typeof jsonValue === 'string') {
            localStorage.setItem(key, jsonValue);
        }
    };

    // Native call these?
    global.Internal = {
        appVersionNotSupportCallback: function appVersionNotSupportCallback(data) {
            config.debug && console.warn(data);
        },
        paramErrorCallback: function paramErrorCallback(data) {
            config.debug && console.warn(data);
        }
    };

    global.__bridge_callback = execCallback;

    return bridge;
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/lib/bridge.js
// module id = 52
// module chunks = 1 4